/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Flow_Not_Available_LabelInputs */

const en_onboarding_flow_not_available_label = /** @type {(inputs: Onboarding_Flow_Not_Available_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not available`)
};

const de_onboarding_flow_not_available_label = /** @type {(inputs: Onboarding_Flow_Not_Available_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verfügbar`)
};

const pt_br2_onboarding_flow_not_available_label = /** @type {(inputs: Onboarding_Flow_Not_Available_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponível`)
};

const tr_onboarding_flow_not_available_label = /** @type {(inputs: Onboarding_Flow_Not_Available_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanılamıyor`)
};

const zh_cn2_onboarding_flow_not_available_label = /** @type {(inputs: Onboarding_Flow_Not_Available_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不可用`)
};

const zh_hk2_onboarding_flow_not_available_label = /** @type {(inputs: Onboarding_Flow_Not_Available_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法使用`)
};

const ko_kr2_onboarding_flow_not_available_label = /** @type {(inputs: Onboarding_Flow_Not_Available_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용할 수 없음`)
};

const ru_ru2_onboarding_flow_not_available_label = /** @type {(inputs: Onboarding_Flow_Not_Available_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недоступно`)
};

const es_419_onboarding_flow_not_available_label = /** @type {(inputs: Onboarding_Flow_Not_Available_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible`)
};

/**
* | output |
* | --- |
* | "Not available" |
*
* @param {Onboarding_Flow_Not_Available_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_flow_not_available_label = /** @type {((inputs?: Onboarding_Flow_Not_Available_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Flow_Not_Available_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_flow_not_available_label(inputs)
	if (locale === "de") return de_onboarding_flow_not_available_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_flow_not_available_label(inputs)
	if (locale === "tr") return tr_onboarding_flow_not_available_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_flow_not_available_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_flow_not_available_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_flow_not_available_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_flow_not_available_label(inputs)
	return es_419_onboarding_flow_not_available_label(inputs)
});